import { render, staticRenderFns } from "./CreatePurchaseOrderItemCard.vue?vue&type=template&id=88367cf0"
import script from "./CreatePurchaseOrderItemCard.ts?vue&type=script&lang=ts&external"
export * from "./CreatePurchaseOrderItemCard.ts?vue&type=script&lang=ts&external"
import style0 from "./create-purchase-order-item-card.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports